const partnerTiles = [
  {
    h: 'New Lab',
    href: 'https://newlab.com/',
    img: {
      src: '/publicAssets/partners/newlab.svg',
      width: '200px',
      alt: 'New Lab'
    },
    type: 'SUPPORT'
  },
  //  {
  //    h: 'Perkins Coie',
  //    href: 'https://perkinscoie.com/',
  //    img: {
  //      src: '/publicAssets/partners/perkinscoie.png',
  //      width: '200px',
  //      alt: 'Perkins Coie'
  //      // style: { paddingTop: '25px' }
  //    },
  //    type: 'SUPPORT'
  //  },
  {
    h: 'Tendermint',
    href: 'https://tendermint.com',
    img: {
      src: '/publicAssets/partners/tendermint.png',
      width: '200px',
      alt: 'Navel'
    },
    type: 'SUPPORT'
  },
  {
    h: 'Navel',
    href: 'http://navel.la',
    img: {
      src: '/publicAssets/partners/navel_scribble.png',
      width: '200px',
      alt: 'Navel'
    },
    type: 'SUPPORT'
  }
]

export { partnerTiles }



// WEBPACK FOOTER //
// ./src/content/partnerTiles.js